/**
 * Modelo e versão do Android lidos do User-Agent da WebView.
 *
 * <p><b>Por que existe:</b> no modo embedded o player roda numa WebView dentro do
 * APK do parceiro, e o host (AAR) hoje injeta só identidade e URL — nada de
 * hardware. Sem isto, o `EmbeddedPlatformService` herda o `getDeviceInfo` do
 * Browser e reporta `model: "Chrome Browser"` com `platformVersion:
 * "Linux armv8l"`. O aparelho é um tablet Samsung rodando Android, e a tela de
 * players mostrava um navegador.</p>
 *
 * <p>A WebView Android põe as duas coisas no UA:</p>
 *
 * <pre>Mozilla/5.0 (Linux; Android 12; SM-T505 Build/SP1A.210812.016; wv) AppleWebKit/…</pre>
 *
 * <p>Isto é o caminho de HOJE, que chega pela OTA do bundle sem o parceiro
 * recompilar nada. Quando o AAR passar a injetar `Build.MODEL` e companhia, esses
 * valores têm precedência — o UA vira fallback.</p>
 */

/**
 * Modelos que o Chrome emite quando a "User-Agent Reduction" está ativa: o valor
 * real é substituído por um marcador. Reportar "K" como modelo do tablet seria
 * pior que não reportar — parece dado, e não é.
 */
const MODELOS_PLACEHOLDER = new Set(['k', 'build']);

export interface AndroidDoUserAgent {
  /** Release do Android, limpa: `"12"`, `"16"`. Mesma forma que a frota manda. */
  osVersion: string | null;
  /** `Build.MODEL`, quando o UA o traz: `"SM-T505"`. */
  model: string | null;
}

const VAZIO: AndroidDoUserAgent = { osVersion: null, model: null };

export function parseAndroidUserAgent(
  ua: string | null | undefined,
): AndroidDoUserAgent {
  if (!ua) return VAZIO;

  const versao = /Android\s+(\d+(?:\.\d+)*)/i.exec(ua);
  if (!versao) return VAZIO;

  // O modelo vem logo depois da versão, e o sufixo ` Build/…` é opcional —
  // algumas WebViews omitem.
  const modelo =
    /Android\s+\d+(?:\.\d+)*;\s*([^;)]+?)(?:\s+Build\/[^;)]*)?\s*[;)]/i.exec(
      ua,
    );
  const bruto = modelo?.[1]?.trim();
  const limpo =
    bruto && !MODELOS_PLACEHOLDER.has(bruto.toLowerCase()) && bruto.length > 1
      ? bruto
      : null;

  return { osVersion: versao[1], model: limpo };
}
